import { useEffect, useMemo } from 'react';
import { useLazyFetchLlmIntegrationModelsListQuery } from '../../../store/integrations/integrationsApi';

export const useGetModelMappings = (providerType, selectedModel) => {
  const [fetchModels, { data: rawModelData = [], isFetching, isLoading }] = useLazyFetchLlmIntegrationModelsListQuery();

  // Fetch the new models every time we change provider
  useEffect(() => {
    if (providerType) {
      fetchModels({ providerType });
    }
  }, [providerType, fetchModels]);

  // Build the models list every time we fetch new data
  // Check for uniqueness to avoid duplicates
  const modelOptions = useMemo(() => {
    const uniqueModels = new Set();
    const raw = rawModelData || [];

    raw.forEach((item) => {
      if (item.name) {
        uniqueModels.add(item.name);
      }
      if (item.variations) {
        item.variations.forEach((alt) => uniqueModels.add(alt));
      }
    });

    return Array.from(uniqueModels).map((modelName) => ({
      value: modelName,
      label: modelName
    }));

  }, [rawModelData]);

  // Find and retrieve the mappings associated with the selected model
  const mappings = useMemo(() => {
    if (!selectedModel || !rawModelData || rawModelData.length === 0) {
      return [];
    }

    const foundModel = rawModelData.find(model =>
      model.name === selectedModel || (model.variations && model.variations.includes(selectedModel))
    );

    return foundModel ? (foundModel.properties || []) : [];
  }, [selectedModel, rawModelData]);

  return {
    modelOptions,
    mappings,
    rawModelData,
    isLoadingModels: isLoading || isFetching
  };
};
